<template>
  <div>
    <div class="vs-row">
      <vs-col vs-xs="12">
        <div class="con-vs-card cardx">
          <div class="vs-card--content p-4">
            <div class="md:flex">
              <vs-chip class="my-0 mr-3" color="personal">Personal</vs-chip>
              <vs-chip class="my-0 mr-3" color="professional"
                >Professional</vs-chip
              >
              <vs-chip class="my-0 mr-3" color="work">Work</vs-chip>
              <vs-chip class="my-0 mr-3" color="home">Home</vs-chip>
              <vs-chip class="my-0 mr-3" color="office">Office</vs-chip>

              <vs-button
                color="success"
                @click="AddNewEvent(new Date())"
                class="whitespace-no-wrap ml-auto"
                ><i class="icon-calendar"></i> Add Event</vs-button
              >
            </div>
          </div>
        </div>
      </vs-col>
      <vs-col vs-xs="12">
        <div class="con-vs-card cardx">
          <div class="vs-card--content p-4">
            <calendar-view
              :show-date="showDate"
              :events="events"
              enableDragDrop
              @drop-on-date="eventDragged"
              @click-event="openEditEvent"
              class="theme-default"
              
            >
              <calendar-view-header
                slot="header"
                slot-scope="t"
                :header-props="t.headerProps"
                @input="setShowDate"
              />
            </calendar-view>
            <!-- ADD EVENT -->
            <vs-prompt
              class="calendar-event-dialog"
              title="Add Event"
              accept-text="Add Event"
              @accept="addEvent"
              :is-valid="validForm"
              :active.sync="activePromptAddEvent"
            >
              <vs-chip class="float-right" v-if="labelLocal != 'none'" :color="labelLocal">{{
                labelLocal
              }}</vs-chip>
              <vs-dropdown>
                <a class="a-icon" href.prevent>
                  <i class="mr-2 icon-tag"></i>
                </a>

                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(label, index) in calendarLabels"
                    :key="index"
                    @click="labelLocal = label.value"
                  >
                    <div
                      class="h-3 w-3 mb-3 inline-block rounded-full mr-2"
                      :class="'bg-' + label.color"
                    >
                      <vs-chip class="my-0 mb-3 d-block" :color="label.value">{{
                        label.text
                      }}</vs-chip>
                    </div>
                    <span>{{ label.text }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <vs-input
                name="event-name"
                class="w-full"
                label-placeholder="Event Title"
                v-model="title"
              ></vs-input>
              <div class="my-4">
                <small class="date-label">Start Date</small>
                <datepicker
                  name="start-date"
                  v-model="startDate"
                  input-class="vs-inputx vs-input--input normal"
                ></datepicker>
              </div>
              <div class="my-4">
                <small class="date-label">End Date</small>
                <datepicker
                  name="end-date"
                  v-model="endDate"
                  input-class="vs-inputx vs-input--input normal"
                ></datepicker>
              </div>
              <vs-input
                name="event-url"
                class="w-full mt-6"
                label-placeholder="Event URL"
                v-model="url"
              ></vs-input>
            </vs-prompt>


            <!-- Edit EVENT -->
        <vs-prompt
        class="calendar-event-dialog"
        title="Edit Event"
        accept-text= "Submit"
        cancel-text = "Remove"
        button-cancel = "border"
        @cancel="removeEvent"
        @accept="editEvent"
        :is-valid="validForm"
        :active.sync="activePromptEditEvent">
              <vs-chip class="float-right" v-if="labelLocal != 'none'" :color="labelLocal">{{
                labelLocal
              }}</vs-chip>
              <vs-dropdown>
                <a class="a-icon" href.prevent>
                  <i class="mr-2 icon-tag"></i>
                </a>

                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(label, index) in calendarLabels"
                    :key="index"
                    @click="labelLocal = label.value"
                  >
                    <div
                      class="h-3 w-3 mb-3 inline-block rounded-full mr-2"
                      :class="'bg-' + label.color"
                    >
                      <vs-chip class="my-0 mb-3 d-block" :color="label.value">{{
                        label.text
                      }}</vs-chip>
                    </div>
                    <span>{{ label.text }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>

              <vs-input
                name="event-name"
                class="w-full"
                label-placeholder="Event Title"
                v-model="title"
              ></vs-input>
              <div class="my-4">
                <small class="date-label">Start Date</small>
                <datepicker
                  name="start-date"
                  v-model="startDate"
                  input-class="vs-inputx vs-input--input normal"
                ></datepicker>
              </div>
              <div class="my-4">
                <small class="date-label">End Date</small>
                <datepicker
                  name="end-date"
                  v-model="endDate"
                  input-class="vs-inputx vs-input--input normal"
                ></datepicker>
              </div>
              <vs-input
                name="event-url"
                class="w-full mt-6"
                label-placeholder="Event URL"
                v-model="url"
              ></vs-input>
            </vs-prompt>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";
import Datepicker from "vuejs-datepicker";
require("vue-simple-calendar/static/css/default.css");
require("vue-simple-calendar/static/css/holidays-us.css");

export default {
  name: "app",
  data: function () {
    return {
      showDate: new Date(),
      activePromptAddEvent: false,
      activePromptEditEvent: false,
      id: 0,
      title: "",
      startDate: "",
      endDate: "",
      labelLocal: "none",
      url: "",
      calendarLabels: [
        { text: "Personal", value: "personal", color: "personal" },
        { text: "Professional", value: "professional", color: "professional" },
        { text: "Work", value: "work", color: "work" },
        { text: "Home", value: "home", color: "home" },
        { text: "Office", value: "office", color: "office" },
      ],
      events: [
        {
          id: 1,
          title: "Long Event",
          startDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 3),
          endDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 2),
          classes: "event-personal",
          url: "",
          label: "personal",
        },
        {
          id: 2,
          title: "Repeating Event",
          startDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 7),
          endDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 6),
          classes: "event-professional",
          url: "",
          label: "professional",
        },
        {
          id: 3,
          title: "Conference",
          startDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 1),
          endDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 1),
          classes: "event-work",
          url: "",
          label: "work",
        },
        {
          id: 4,
          title: "Click for Google",
          url: "http://google.com/",
          startDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 21),
          endDate: new Date(new Date() - 1000 * 60 * 60 * 24 * 20),
          classes: "event-home",
          label: "home",
        },
      ],
    };
  },
  computed: {
    validForm() {
      return (
        this.title != "" &&
        this.startDate != "" &&
        this.endDate != "" &&
        Date.parse(this.endDate) - Date.parse(this.startDate) >= 0
      );
    },
  },
  components: {
    CalendarView,
    CalendarViewHeader,
    Datepicker,
  },
  methods: {
    addEvent() {
      const obj = {
        title: this.title,
        startDate: new Date(this.startDate).getTime(),
        endDate: new Date(this.endDate).getTime(),
        label: this.labelLocal,
        url: this.url,
        classes: "event-" + this.labelLocal,
      };
      const length = this.events.length;
      let lastIndex = 0;
      if (length) {
        lastIndex = this.events[length - 1].id;
      }
      obj.id = lastIndex + 1;
      this.events.push(obj);
    },

    setShowDate(d) {
      this.showDate = d;
    },
    eventDragged(passevent, date) {
      let event = this.events.find((oevent) => oevent.id == passevent.id);
      const eventStartDate = new Date(event.startDate).getTime();
      const eventEndDate = new Date(event.endDate).getTime();
      const diff = date - eventStartDate;
      const newEndDate = new Date(eventEndDate + diff);
      event.startDate = new Date(date).getTime();
      event.endDate = newEndDate;
      return event;
    },
    AddNewEvent(date) {
      this.title = this.endDate = this.url = "";
      this.id = 0;
      this.labelLocal = "none";
      this.startDate = date;
      this.endDate = date;
      this.activePromptAddEvent = true;
    },
    openEditEvent(event) {
      const e =  this.events.find((oevent) => oevent.id == event.id);
      this.id = e.id
      this.title = e.title
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.url = e.url
      this.labelLocal = e.label
      this.activePromptEditEvent = true;      
    },
    editEvent() {
      const obj = { id: this.id, title: this.title, startDate: this.startDate, endDate: this.endDate, label: this.labelLocal, url: this.url }
      obj.classes = "event-" + this.labelLocal
       let event = this.events.find((event) => event.id == this.id)
  Object.assign(event, obj)
    },
    removeEvent() {
      const eventIndex = this.events.findIndex((event) => event.id == this.id)
  this.events.splice(eventIndex, 1)
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/styles/apps/calendar.scss";
</style>